import React from 'react';
import { SelectProps } from 'antd/lib/select';
import { Select } from 'antd';
import { UserSubscription } from '../../../../hooks/api/user';
import { Option } from '../../../../types';

export const caloriesDataOptions = [1500, 1700, 1900, 2100] as const;

function SelectCalories({ ...props }: SelectProps<UserSubscription, Option>) {
  return (
    <Select {...props} />
  );
}

SelectCalories.defaultProps = {
  options: caloriesDataOptions.map((el) => ({ label: el, value: el })),
  allowClear: true,
  placeholder: 'Выберите',
};

export default SelectCalories;
